import {
  CHANGE_DATE_RANGE
} from "../actions/types";

const INITIAL_STATE = {
  startDate: null,
  endDate: null,
  key: "selection"
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_DATE_RANGE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/date_range_reducer.js